export var OrderPaymentType;
(function (OrderPaymentType) {
    OrderPaymentType[OrderPaymentType["PAYMENT"] = 1] = "PAYMENT";
    OrderPaymentType[OrderPaymentType["BALANCE_CLEAR"] = 2] = "BALANCE_CLEAR";
    OrderPaymentType[OrderPaymentType["CREDIT"] = 3] = "CREDIT";
})(OrderPaymentType || (OrderPaymentType = {}));
//# sourceMappingURL=order-payment-type.js.map